module.exports = __webpack_public_path__ + "img/coreintercomDesk.c3fa1636.png";